var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 54,
    viewBox: "0 0 107 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#263e52;}.b{fill:#10c6b5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1115.194 -4667.244)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7951.714,14187.8s-2.682-2.282-12.385-3.238a45.459,45.459,0,0,0-12.2.21,24.334,24.334,0,0,0-16.5,11.407,30.6,30.6,0,0,0-3.425,14.434c-.085,5.793.812,13.487,6.04,19.611s13.527,7.734,20.129,7.54a98.466,98.466,0,0,0,17.679-2.569,3.987,3.987,0,0,0,1.577-.883v-27.582h-22.613v10.8h9.393v7.746s-1.277.783-5.423.684-12.144-.971-12.144-15.349,12.144-14.434,12.144-14.434a24.862,24.862,0,0,1,8.138.693c4.077,1.121,4.964,2.092,4.964,2.092Z",
    transform: "translate(-6792 -9517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7025.067-9463.8c-2.23-.43-11.6-1.551-16.715-11.129-2.191-3.984-3.131-9.117-3.212-14.709l0-.2h0q0-.158,0-.316t0-.316h0c0-.067,0-.132,0-.2a30.627,30.627,0,0,1,3.424-14.435,22.236,22.236,0,0,1,5.327-6.2,24.726,24.726,0,0,1,4.818-3.092,25.41,25.41,0,0,1,6.359-2.114,31.555,31.555,0,0,1,5.626-.5,35.888,35.888,0,0,1,6.39.587,39.8,39.8,0,0,1,5.146,1.286,32.256,32.256,0,0,1,4.683,1.875l-4.528,10.939-5.04-1.6a19.567,19.567,0,0,0-5.792-.99,10.157,10.157,0,0,0-7.726,3.175l-.032.03a12.413,12.413,0,0,0-2.868,4.322,18.165,18.165,0,0,0-1.149,6.714v.2h.009c0,.1,0,.211-.005.316s0,.212.005.316h-.009v.2a18.176,18.176,0,0,0,1.149,6.714,12.386,12.386,0,0,0,2.868,4.322l.032.031a10.157,10.157,0,0,0,7.726,3.172,33.445,33.445,0,0,0,12.879-3.172s-.179,5.873,0,12.4c-1.687.543-5.62,1.971-7.347,2.282a35.982,35.982,0,0,1-6.39.588A31.375,31.375,0,0,1-7025.067-9463.8Z",
    transform: "translate(8209.576 14184.275)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 7.655,
    cy: 7.205,
    rx: 7.655,
    ry: 7.205,
    transform: "translate(1206.884 4706.834)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGc);
export default __webpack_public_path__ + "static/media/gc.1d4755778bf3134ea4523b5b2b409b1f.svg";
export { ForwardRef as ReactComponent };